import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ORCTooltip } from '@ontruck/orc';
import { useDispatch } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';

const TooltipContent = ({ children, segmentTitle, segmentData }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (segmentTitle) {
      dispatch(
        analyticsActions.sendEvent(
          analyticsEvents.tooltipShownEvent({
            title: segmentTitle,
            content: typeof children === 'string' ? children : '<component>',
            extraData: segmentData,
          })
        )
      );
    }
  }, [dispatch, children, segmentData, segmentTitle]);
  return <div>{children}</div>;
};

const Tooltip = ({
  component,
  skin,
  position,
  alwaysVisible,
  segmentTitle,
  segmentData,
  className,
  children,
}) => {
  return (
    <span className={className} data-testid="tooltip">
      <ORCTooltip
        component={
          <TooltipContent segmentTitle={segmentTitle} segmentData={segmentData}>
            {component}
          </TooltipContent>
        }
        skin={skin}
        position={position}
        alwaysVisible={alwaysVisible}
      >
        {children}
      </ORCTooltip>
    </span>
  );
};

Tooltip.propTypes = {
  className: PropTypes.string,
  skin: PropTypes.string,
  position: PropTypes.string,
  segmentTitle: PropTypes.string,
  segmentData: PropTypes.any,
  alwaysVisible: PropTypes.bool,
  component: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};

Tooltip.defaultProps = {
  skin: 'dark',
  position: 'top',
};

export default Tooltip;
